import { z } from 'zod';
/** How a box deposits cash:
 *   'direct'   → straight from receipts (the original flow).
 *   'register' → through a cash register → safe → bank deposit. In this mode
 *                cash disappears from the receipts deposit screen (it lives in
 *                the register instead) and that screen becomes checks-only. */
export const CashModeSchema = z.enum(['direct', 'register']);
export const BoxSettingsSchema = z.object({
    box_id: z.number(),
    default_depositor_user_boxes_id: z.number().nullable(),
    /** Whether the box handles cash receipts at all. */
    handles_cash: z.boolean(),
    /** Whether the box handles check receipts at all. */
    handles_checks: z.boolean(),
    cash_mode: CashModeSchema,
    /** Whether the box separates data per location. When false, locations are
     *  treated as one bucket (dummy-location boxes) — single register/safe,
     *  box-wide receipt fetches, location picker hidden. */
    manage_locations: z.boolean(),
    /** Whether the box separates data per Arbox project (a layer under
     *  locations). Default false. When true, registers / safe / deposits and their
     *  numbering split per (location, project), with "no project" as its own
     *  bucket, and a project picker appears. */
    manage_projects: z.boolean(),
    /** Whether new deposits (and cancellations) are reported to Arbox's Vendor
     *  API so they land in the accounting journal export. Default false — opt-in
     *  per box for a gradual rollout. */
    report_deposits_to_arbox: z.boolean(),
    /** Whether the box uses petty cash (קופה קטנה): a cash stash loaded from
     *  cash receipts, with expenses documented out of it. Default false. */
    petty_cash_enabled: z.boolean(),
    /** Whether the box deposits credit card payments (הפקדות אשראי, migration
     *  014). Default false. The rest of the credit settings are per location. */
    credit_enabled: z.boolean(),
});
export const BoxSettingsUpdateSchema = z.object({
    default_depositor_user_boxes_id: z.number().nullable().optional(),
    handles_cash: z.boolean().optional(),
    handles_checks: z.boolean().optional(),
    cash_mode: CashModeSchema.optional(),
    manage_locations: z.boolean().optional(),
    manage_projects: z.boolean().optional(),
    report_deposits_to_arbox: z.boolean().optional(),
    petty_cash_enabled: z.boolean().optional(),
    credit_enabled: z.boolean().optional(),
});
//# sourceMappingURL=box-settings.js.map